import React from 'react';
import { Typography, Tabs } from 'antd';
import {
  LinkOutlined,
  WarningOutlined,
  MedicineBoxOutlined,
  UserOutlined,
  CopyOutlined,
} from '@ant-design/icons';
import VinculacionResumenTab from '../components/VinculacionCU2/VinculacionResumenTab';
import VinculacionIncoherenciasTab from '../components/VinculacionCU2/VinculacionIncoherenciasTab';
import VinculacionFarmaciasCU2SinVincularTab from '../components/VinculacionCU2/VinculacionFarmaciasCU2SinVincularTab';
import VinculacionFarmaciasSinVincularTab from '../components/VinculacionCU2/VinculacionFarmaciasSinVincularTab';
import VinculacionTitularesSinVincularTab from '../components/VinculacionCU2/VinculacionTitularesSinVincularTab';
import VinculacionFarmaciasDuplicadasTab from '../components/VinculacionCU2/VinculacionFarmaciasDuplicadasTab';

const { Title } = Typography;

/**
 * Vinculación CU2 — panel portado del panel Python (VinculacionCU2-AQ).
 * 4 pestañas: Vinculación (resumen), Incoherencias, Farmacias Gescom-AQ sin vincular,
 * Titulares Gescom-AQ sin vincular. Acceso con permiso GCvsc.Reconciliacion.Read.
 */
const VinculacionCU2Page: React.FC = () => {
  const items = [
    {
      key: 'vinculacion',
      label: (
        <span>
          <LinkOutlined /> Vinculación
        </span>
      ),
      children: <VinculacionResumenTab />,
    },
    {
      key: 'incoherencias',
      label: (
        <span>
          <WarningOutlined /> Incoherencias
        </span>
      ),
      children: <VinculacionIncoherenciasTab />,
    },
    {
      key: 'farmacias-cu2-sv',
      label: (
        <span>
          <MedicineBoxOutlined /> Farmacias CU2 sin vincular
        </span>
      ),
      children: <VinculacionFarmaciasCU2SinVincularTab />,
    },
    {
      key: 'farmacias-sv',
      label: (
        <span>
          <MedicineBoxOutlined /> Farmacias Gescom-AQ sin vincular
        </span>
      ),
      children: <VinculacionFarmaciasSinVincularTab />,
    },
    {
      key: 'titulares-sv',
      label: (
        <span>
          <UserOutlined /> Titulares Gescom-AQ sin vincular
        </span>
      ),
      children: <VinculacionTitularesSinVincularTab />,
    },
    {
      key: 'duplicadas-cu2',
      label: (
        <span>
          <CopyOutlined /> Farmacias duplicadas en CU2
        </span>
      ),
      children: <VinculacionFarmaciasDuplicadasTab />,
    },
  ];

  return (
    <div>
      <Title level={2} style={{ marginBottom: 24 }}>
        <LinkOutlined style={{ marginRight: 12 }} />
        Vinculación CU2 ↔ Gescom-AQ
      </Title>
      <Tabs defaultActiveKey="vinculacion" items={items} />
    </div>
  );
};

export default VinculacionCU2Page;
